import { render, staticRenderFns } from "./EditSynonym.vue?vue&type=template&id=39eed8d6&scoped=true&"
import script from "./EditSynonym.vue?vue&type=script&lang=js&"
export * from "./EditSynonym.vue?vue&type=script&lang=js&"
import style0 from "./EditSynonym.vue?vue&type=style&index=0&id=39eed8d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eed8d6",
  null
  
)

export default component.exports